<template>
  <div>
    <PageAllow controller="Shops" action="getShopBalanceHistories" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("capitalDetail.title") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("Announcement.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("capitalDetail.Fields.shop_code")
                }}{{ $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                {{ shop.shop_code }}
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("capitalDetail.Fields.shop_name")
                }}{{ $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                {{ shop.shop_name }}
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("capitalDetail.Fields.district_name")
                }}{{ $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                {{ shop.district ? shop.district.name : "" }}
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("capitalDetail.Fields.address") }}{{ $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                {{ shop.address }}
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("capitalDetail.Fields.status") }}{{ $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-chip
                  small
                  label
                  :color="
                    shop.status == 0 || shop.status == 2 || shop.status == 3
                      ? 'danger'
                      : 'primary'
                  "
                >
                  <span v-if="shop.status == 0">
                    {{ $t("capitalDetail.status.status_off") }}
                  </span>
                  <span v-if="shop.status == 1">
                    {{ $t("capitalDetail.status.status_on") }}
                  </span>
                  <span v-if="shop.status == 2">
                    {{ $t("capitalDetail.status.status_stop") }}
                  </span>
                  <span v-if="shop.status == 3">
                    {{ $t("capitalDetail.status.status_addears") }}
                  </span>
                </v-chip>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("capitalDetail.Fields.reg_flg") }}{{ $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                {{
                  shop.reg_flg == 0
                    ? $t("capitalDetail.regFlg.off")
                    : $t("capitalDetail.regFlg.on")
                }}
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("capitalDetail.Fields.shop_user_name")
                }}{{ $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                {{ shop.shop_user ? shop.shop_user.name : "" }}
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("capitalDetail.Fields.tel") }}{{ $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <span v-if="shop && shop.shop_user">
                  {{ shop.shop_user.tel }}
                </span>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click="
                    $emit('input', null);
                    $emit('mode', null);
                  "
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backToList", [$t("capital.ObjectName")]) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
        <v-card class="mt-4">
          <v-card-title class="pa-0">
            <v-list dense width="100%">
              <v-list-item>
                <v-btn color="primary" class="my-1 elevation-1" block>
                  <span
                    >{{
                      $t("capitalDetail.balance") +
                      $t("Global.colon") +
                      $t("Global.money")
                    }}{{ shop.balance | formatMoney }}</span
                  >
                </v-btn>
              </v-list-item>
              <!-- 充值 -->
              <v-list-item>
                <v-btn
                  @click.stop="rechargeDialog = true"
                  outlined
                  color="primary"
                  class="elevation-1 my-1"
                  block
                >
                  <span>
                    {{ $t("capitalDetail.recharge") }}
                  </span>
                </v-btn>
              </v-list-item>
              <!-- 扣款 -->
              <v-list-item>
                <v-btn
                  @click.stop="deductionDialog = true"
                  outlined
                  color="primary"
                  class="elevation-1 my-1"
                  block
                >
                  <span>
                    {{ $t("capitalDetail.deduction") }}
                  </span>
                </v-btn>
              </v-list-item>
              <v-list-item>
                <v-btn
                  outlined
                  color="primary"
                  class="elevation-1 my-1"
                  block
                  :disabled="!shop.id"
                  @click.stop="routerAccountHistory(shop)"
                >
                  <span>
                    {{ $t("capitalDetail.history") }}
                  </span>
                </v-btn>
              </v-list-item>
              <v-list-item>
                <v-btn
                  outlined
                  color="primary"
                  class="elevation-1 my-1"
                  block
                  :disabled="!shop.id && !shop.shop_name"
                  @click.stop="
                    $router.push({
                      path: '/receipt-history',
                      query: { shopId: shop.id, shopName: shop.shop_name },
                    })
                  "
                >
                  <span>
                    {{ $t("capitalDetail.history_view") }}
                  </span>
                </v-btn>
              </v-list-item>
            </v-list>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>

    <v-dialog v-model="rechargeDialog" width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("capitalDetail.recharge") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="rechargeDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 text-center subtitle-1">
          <v-row>
            <v-col cols="3" class="font-weight-bold text-right">
              {{ $t("capitalDetail.price") }}{{ $t("Global.colon") }}
            </v-col>
            <v-col cols="9">
              <v-text-field
                v-model="rechargePrice"
                single-line
                dense
                hide-details
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  rechargePrice
                    ? (rechargePrice = $numberFormatter.formatWithDotNoMoreThan(
                        rechargePrice,
                        2
                      ))
                    : ''
                "
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="$permission.permissionAllow('BalanceCategories', 'index')"
          >
            <v-col cols="3" class="font-weight-bold text-right">
              {{ $t("capitalDetail.balanceCategories")
              }}{{ $t("Global.colon") }}
            </v-col>
            <v-col cols="9">
              <v-autocomplete
                v-model="rechargeBalanceCategory"
                :items="balance_categories"
                :loading="balanceCategoryLoading"
                item-value="id"
                item-text="category_name"
                item-disabled="disabled"
                :label="$t('Global.select')"
                clearable
                dense
              >
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="font-weight-bold text-right">
              {{ $t("capitalDetail.comment") }}{{ $t("Global.colon") }}
            </v-col>
            <v-col cols="9">
              <v-textarea v-model="rechargeComment" outlined auto-grow />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="rechargeDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="accent" depressed @click="recharge()">
            {{ $t("$vuetify.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deductionDialog" width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("capitalDetail.deduction") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="deductionDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 text-center subtitle-1">
          <v-row>
            <v-col cols="3" class="font-weight-bold text-right">
              {{ $t("capitalDetail.balance") }}{{ $t("Global.colon") }}
            </v-col>
            <v-col class="text-left">
              {{ shop.balance | formatMoney }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="font-weight-bold text-right">
              {{ $t("capitalDetail.price") }}{{ $t("Global.colon") }}
            </v-col>
            <v-col cols="9">
              <v-text-field
                v-model="deductionPrice"
                single-line
                dense
                hide-details
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  deductionPrice
                    ? (deductionPrice =
                        $numberFormatter.formatWithDotNoMoreThan(
                          deductionPrice,
                          2
                        ))
                    : ''
                "
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="3" class="font-weight-bold text-right">
              {{ $t("capitalDetail.comment") }}{{ $t("Global.colon") }}
            </v-col>
            <v-col cols="9">
              <v-textarea v-model="deductionComment" outlined auto-grow />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="deductionDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="accent" depressed @click="deduction()">
            {{ $t("$vuetify.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Shop from "@/api/shops";
import Consts from "@/consts.js";
import { mapState } from "vuex";
import BalanceCategories from "@/api/balance_categories";

export default {
  props: ["value", "mode"],

  data: () => ({
    shop: {},
    rechargeDialog: false,
    deductionDialog: false,
    rechargePrice: "",
    rechargeComment: "",
    rechargeBalanceCategory: null,
    deductionPrice: "",
    deductionComment: "",
    balance_categories: [],
    balanceCategoryLoading: false,
  }),

  components: {
    PageAllow,
    Breadcrumbs,
  },
  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isNew() {
      return this.mode == "new";
    },
    status() {
      return Consts.stock.status;
    },
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.capital"),
        disabled: false,
        href: "/capital",
      },
      {
        text: i18n.t("Nav.capitalDetail"),
        disabled: true,
      },
    ],
    ...mapState(["loading"]),
  },

  mounted() {
    this.getCapitalFromAPI();
  },

  methods: {
    getCapitalFromAPI() {
      if (this.value && this.value.id) {
        Shop.fetchOne(this.value.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.shop = response.data.shop;
            }
          }.bind(this)
        );
      }
    },

    recharge() {
      this.$store.dispatch("fullscreenLoading");
      var data = [];
      data.push({
        operation_type: 101,
        shop_id: this.value.id,
        comment: this.rechargeComment,
        price: this.rechargePrice,
        balance_category_id: this.rechargeBalanceCategory,
      });
      Shop.editBalance(data[0]).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.rechargePrice = "";
            this.rechargeComment = "";
            this.getCapitalFromAPI();
          }
          this.rechargeDialog = false;
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },

    deduction() {
      this.$store.dispatch("fullscreenLoading");
      var data = [];
      data.push({
        operation_type: 201,
        shop_id: this.value.id,
        comment: this.deductionComment,
        price: this.deductionPrice,
      });
      Shop.editBalance(data[0]).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.deductionPrice = "";
            this.deductionComment = "";
            this.getCapitalFromAPI();
          }
          this.deductionDialog = false;
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },

    getBalanceCategoriesFromAPI() {
      this.balanceCategoryLoading = true;
      BalanceCategories.fetchAll({}).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.balanceCategoryLoading = false;
            this.balance_categories = response.data.balance_categories;
          }
          this.balanceCategoryLoading = false;
        }.bind(this)
      );
    },
    routerAccountHistory(shop) {
      sessionStorage.setItem("account-history-shopsSelected", JSON.stringify([shop]));
      this.$router.push({path: '/account-history',})
    }
  },

  watch: {
    value: {
      immediate: true,
      handler() {
        this.shop = {};
        this.getCapitalFromAPI();
      },
    },
    rechargeDialog: {
      handler() {
        if (this.rechargeDialog) {
          this.getBalanceCategoriesFromAPI();
        } else if (!this.rechargeDialog) {
          this.rechargePrice = "";
          this.rechargeComment = "";
          this.rechargeBalanceCategory = null;
        }
      },
    },
  },
};
</script>

<style>
</style>